// extracted by mini-css-extract-plugin
module.exports = {"container":"ReadMore_container__1rAuv","content":"ReadMore_content__DlHzw","showHideController":"ReadMore_showHideController__2sxaV","emptyBody":"ReadMore_emptyBody__3WeBr"};